module.exports = __webpack_public_path__ + "static/media/13ITC1.f1afed4b.jpg";